import { render, staticRenderFns } from "./InvoiceCreateEdit.vue?vue&type=template&id=48926880&"
import script from "./InvoiceCreateEdit.vue?vue&type=script&lang=js&"
export * from "./InvoiceCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCreateEdit.vue?vue&type=style&index=0&id=48926880&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports